<template>
  <section class="dashboard-card">
    <header class="dashboard-card-header">
      <div class="flex items-center">
        <VSvgIcon name="calendarHeart" />
        <h2 class="dashboard-card-header-heading">{{ $t('dashboard.events.heading') }}</h2>
      </div>
    </header>
    <div class="text-center p-4 overflow-y-auto max-h-74">
      <div class="flex justify-center items-center mb-4">
        <img src="../../assets/decosummit.svg" alt="decosummit logo" class="" />
        <span class="ml-2">DecoSummit</span>
      </div>
      <EventRow v-for="(eventCode, index) in eventsCodes" :key="index" :eventCode="eventCode" />
    </div>
  </section>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';
import EventRow from '@/components/customer/DashboardEventRow';

export default {
  name: 'DashboardEvents',
  components: { VSvgIcon, EventRow },
  props: { eventsCodes: Array },
  computed: {},
  methods: {},
  async created() {
    console.log(this.eventsCodes, 1);
  },
};
</script>
